// Ciscenje adrese kod uvoza eRacuna.
//
// ZASTO: jedan posiljatelj (Chip) u adresu kupca upisuje NAZIVE POLJA umjesto
// vrijednosti:
//
//   <cbc:StreetName>Miroslava Kržele 30Ulica</cbc:StreetName>
//   <cbc:CityName>40000 ČAKOVEC</cbc:CityName>
//   <cbc:PostalZone>Pošt.br.</cbc:PostalZone>
//
// Uvoz je to prepisivao doslovno, pa je partner dobivao grad "40000 ČAKOVEC",
// postanski broj "Pošt.br." i ulicu sa zalijepljenom rijeci "Ulica".
//
// Pravila su namjerno uska - diraju samo ono sto je ocito pokvareno:
//   1. postanski broj bez ijedne znamenke = naziv polja, ne broj -> prazni se,
//   2. ako postanskog broja nema, a grad pocinje s 4-5 znamenaka, broj se
//      odvaja iz grada,
//   3. s kraja ulice skida se "Ulica" SAMO kad je zalijepljena uz znamenku
//      ("30Ulica"). Pisana odvojeno ostaje - "Duga ulica" je pravi naziv.
//
// Ispravna adresa prolazi nedirnuta.

const tekst = (v) => (v === null || v === undefined ? '' : String(v).trim())

/** Ima li vrijednost ijednu znamenku. */
const imaZnamenku = (v) => /[0-9]/.test(tekst(v))

/**
 * @param {Object} a {ulica, grad, posta}
 * @returns {Object} {ulica, grad, posta} - ocisceno
 */
export const ocistiAdresu = (a) => {
  const u = a || {}
  let ulica = tekst(u.ulica)
  let grad = tekst(u.grad)
  let posta = tekst(u.posta)

  // 1. "Pošt.br.", "Post.broj", "-" ... sve bez znamenke nije postanski broj
  if (posta && !imaZnamenku(posta)) { posta = '' }

  // 2. "40000 ČAKOVEC" -> "40000" + "ČAKOVEC"
  if (!posta) {
    const m = grad.match(/^([0-9]{4,5})\s+(.+)$/)
    if (m) {
      posta = m[1]
      grad = m[2].trim()
    }
  }

  // 3. "Miroslava Kržele 30Ulica" -> "Miroslava Kržele 30"
  ulica = ulica.replace(/([0-9])\s*ulica\.?$/i, '$1')

  return {ulica: ulica.trim(), grad: grad.trim(), posta: posta.trim()}
}

export default ocistiAdresu
